import enContent from './en.json';

export const contentLib = {
  en: enContent,
};
